import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"min-height":"45vw"} }
const _hoisted_2 = { class: "content pl-3 w-100" }
const _hoisted_3 = { class: "row mr-3 ml-3 v-theme--light" }
const _hoisted_4 = { class: "mb-4" }

import { Ref, ref, onMounted } from 'vue';
import { useRoute } from 'vue-router'
import UserRoleForm from "@/components/UserRoleForm/UserRoleForm.vue";
import AuthorityCacheApi from "@/services/models/AuthorityCacheApi"
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'UserRoleForm',
  props: {
    showFlash: { type: Function },
    switchContentLoading: { type: Function }
  },
  setup(__props: any) {

const title:Ref<string> = ref('');
const route = useRoute()

const userRoleId: Ref<number | null> = ref(null)
const updateAuthority: Ref<boolean> = ref(false)

const props = __props;

onMounted(() => {
  if (route.params.id) getAuthorities()
  setTitle()
})

async function getAuthorities() {
  const authorityList = await AuthorityCacheApi.getWithParse()
  updateAuthority.value = !!authorityList["octlink.user_role.update"]
}

function setTitle() {
  userRoleId.value = Number(route.params.id)
  const titlePrefix = i18n.global.t('pages.userRoles.title.formTitle')
  const titleSuffix = userRoleId.value ?
    i18n.global.t('pages.userRoles.title.editTitle') :
    i18n.global.t('pages.userRoles.title.createTitle')
  title.value = `${titlePrefix}/${titleSuffix}`
  document.title = title.value
}

function setUserRoleId(id: number) {
  userRoleId.value = id
}

function setContentLoading(status:boolean){
  props.switchContentLoading(status)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h4", _hoisted_2, _toDisplayString(title.value), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(UserRoleForm, {
          userRoleId: userRoleId.value,
          showFlash: props.showFlash,
          updateAuthority: updateAuthority.value,
          onSetUserRoleId: setUserRoleId,
          onSetContentLoading: setContentLoading
        }, null, 8, ["userRoleId", "showFlash", "updateAuthority"])
      ])
    ])
  ]))
}
}

})